<template>
    <div>
        <hts-form-autocomplete
            v-model="remoocCategoryId"
            :label="$t('labels.remoocModule.remoocCategory.find')"
            :required="props.required"
            :server="serverRemoocCategory"
            :text="remoocCategoryName"
            :placeholder="$t('labels.remoocModule.remoocCategory.select')"
            :add="false"
            :remooc-length="remoocLength"
            key-id="_id"
            key-label="name"
            @change="(data:any,dataDetail:any)=>handleChange(data,dataDetail)" />
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  required: {
    type: Boolean,
    default: true
  },
  remoocCategoryIsSelected: {
    type: Object,
    default: () => {}
  },
  length: {
    type: Number,
    default: 0
  }
})
const remoocCategoryId = ref('')
const remoocCategoryName = ref('')
const serverRemoocCategory = $url.vehicle.remoocCategory.find
const emits = defineEmits(['changeInput'])
const remoocLength = ref()

watch(props, () => {
  if (props.remoocCategoryIsSelected) {
    remoocCategoryName.value = props.remoocCategoryIsSelected.name
  } else {
    remoocCategoryName.value = ''
  }
  remoocLength.value = props.length
})

const handleChange = (data: any, dataDetail: any) => {
  emits('changeInput', data, dataDetail)
}
</script>
